import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './supplyInvoicesModuleConfig';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

export interface SupplyInvoiceLine {
  id?: number;
  itemId?: number | null;
  itemVcode?: string | null;
  itemDescr?: string | null;
  unitId?: number | null;
  invoiceQty?: number | null;
  unitPrice?: string | number | null;
  lineTotal?: string | number | null;
  discount?: string | number | null;
  vat?: string | number | null;
  requisitionQty?: number | null;
  enquiryQty?: number | null;
  quotationQty?: number | null;
  deliveryQty?: number | null;
  purchaseOrderQty?: number | null;
  itemNotes?: string | null;
  item?: {
    level1?: string | null;
    level2?: string | null;
    level3?: string | null;
  } | null;
  unit?: { id?: number; ucode?: string | null; descr?: string | null } | null;
}

export interface SupplyInvoiceExpense {
  id?: number;
  itemDescr?: string | null;
  value?: string | number | null;
  vat?: string | number | null;
}

export interface SupplyInvoice {
  id: number;
  invDate?: string | null;
  caseId: number;
  supplierId: number;
  ref?: string | null;
  currencyId?: number | null;
  exchangeRate?: string | number | null;
  exchangeDate?: string | null;
  paymentTerms?: string | null;
  refN?: number | null;
  rcvDate?: string | null;
  dueDate?: string | null;
  purchaseOrderId?: number | null;
  deliveryId?: number | null;
  vesselId?: number | null;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  lineItems?: SupplyInvoiceLine[];
  expenses?: SupplyInvoiceExpense[];
  _count?: { lineItems: number };
  supplyCase?: { id: number; ref?: string | null; caseDate?: string | null } | null;
  order?: {
    id: number;
    ref?: string | null;
    orderDate?: string | null;
    quotationId?: number | null;
    quotation?: { id: number; ref?: string | null; enqId?: number | null } | null;
  } | null;
  delivery?: { id: number; ref?: string | null; dlvDate?: string | null } | null;
  vessel?: { id: number; vesselName: string; vesselAbrv?: string | null; imoNumber?: string | null } | null;
  supplier?: { id: number; name: string; code?: string | null; email?: string | null; isActive?: boolean } | null;
  currency?: { id: number; code: string; name: string; symbol?: string | null; isActive?: boolean } | null;
}

export const useSupplyInvoices = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<SupplyInvoice> | SupplyInvoice[]>(
    `${moduleConfig.module.api.list}${q}`,
    fetcher,
    { revalidateOnFocus: true },
  );
  const normalized = normalizePaginatedListResponse<SupplyInvoice>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useSupplyInvoice = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<SupplyInvoice>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
